"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");
/**
 * Entity which contains data about intersection between two (or more) group of sites.
 *
 * @author Jan Gregor
 */


var GroupOfSitesIntersection =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(GroupOfSitesIntersection, _DomainObject_1$Domai);

  // tslint:disable:prettier

  /**
   * @param id An identifier of this intersection.
   * @param gosIds Identifiers of group of sites which take place in the intersection.
   * @param commonBinding Bindings (or their parts) which are valid at the same time on all groups from {@link gosIds}.
   */
  function GroupOfSitesIntersection(id, gosIds, commonBinding) {
    var _this;

    _classCallCheck(this, GroupOfSitesIntersection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesIntersection).call(this));
    _this.id = id;
    _this.gosIds = gosIds;
    _this.commonBinding = commonBinding;
    return _this;
  }

  return GroupOfSitesIntersection;
}(DomainObject_1.DomainObject);

exports.GroupOfSitesIntersection = GroupOfSitesIntersection; // tslint:enable:prettier

GroupOfSitesIntersection.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(GroupOfSitesIntersection.name);
  return {
    id: builder.id('id'),
    gosIds: builder.listOf(builder.id('externalId')),
    commonBinding: builder.listOf(builder.data('commonBinding', {
      siteId: builder.id('siteId'),
      validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
      validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
    }))
  };
}();